import React, { useContext, useMemo } from 'react';

// @ts-ignore
import timeEntryStatusApproved from '@atom/components/common/svgIcons/timeEntryStatusApproved.svg';
// @ts-ignore
import timeEntryStatusPending from '@atom/components/common/svgIcons/timeEntryStatusPending.svg';
// @ts-ignore
import timeEntryStatusRejected from '@atom/components/common/svgIcons/timeEntryStatusRejected.svg';
import { AssetRequestStatus } from '@atom/types/assetRequest';
import { getDisplayDateTime } from '@atom/utilities/timeUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import ViewRequestContext from '../ViewRequestContext';

import './ardotView.css';

const ReviewStatus = () => {
  const { activeRequest } = useContext(ViewRequestContext);

  const content = useMemo(() => {
    const statusText = `${activeRequest?.reviewBy?.firstName} ${
      activeRequest?.reviewBy?.lastName
    } on ${getDisplayDateTime(activeRequest?.reviewDate)}`;

    switch (true) {
      case activeRequest?.status === AssetRequestStatus.PENDING_REVIEW: {
        return (
          <div styleName="status-container">
            <img src={timeEntryStatusPending} />
            <div styleName="status-text">Waiting for Approval</div>
          </div>
        );
      }
      case activeRequest?.status === AssetRequestStatus.CANCELED &&
        !isNilOrEmpty(activeRequest?.reviewDate):
      case activeRequest?.status === AssetRequestStatus.REJECTED &&
        !isNilOrEmpty(activeRequest?.receiveDate):
      case activeRequest?.status === AssetRequestStatus.PENDING_APPROVAL:
      case activeRequest?.status === AssetRequestStatus.APPROVED: {
        return (
          <div styleName="status-container">
            <img src={timeEntryStatusApproved} />
            <div styleName="status-text">{`Approved by ${statusText}`}</div>
          </div>
        );
      }
      case activeRequest?.status === AssetRequestStatus.REJECTED &&
        isNilOrEmpty(activeRequest?.receiveDate): {
        return (
          <div styleName="status-container">
            <img src={timeEntryStatusRejected} />
            <div styleName="status-text">{`Rejected by ${statusText}`}</div>
          </div>
        );
      }
      case activeRequest?.status === AssetRequestStatus.CANCELED &&
        isNilOrEmpty(activeRequest?.reviewDate): {
        return <div />;
      }
      default:
        return <div />;
    }
  }, [activeRequest]);

  return <div>{content}</div>;
};

export default ReviewStatus;
